module.exports = __webpack_public_path__ + "static/media/112-mute.e39a82c8.svg";